import SelfieRequestLinkHandler from './SelfieRequestLinkHandler';

export default SelfieRequestLinkHandler;
